import BookSolutions from './BookSolutions';

export default BookSolutions;
